import React, { useRef, useEffect } from "react";
import { audioElRef, playAudioClip } from "../../../Utils/AudioPlayer";
import { ReactComponent as PlayButtonSvg } from "../../../../assets/icons/play-button.svg"

function AudioClipContainer({ question, setAudioCompleted = () => {}, stopAudio = false, text = "PLAY AUDIO" }) {

  useEffect(() => {
    if (stopAudio && audioElRef.current) {
      audioElRef.current.pause();
      audioElRef.current.currentTime = 0;
    }
  }, [stopAudio]);

  const handlePlay = () => {
    if (!audioElRef.current) return;
    setAudioCompleted(false);
    audioElRef.current.play();
  };

  const audioElRef = useRef(null);
    return (
      <div>
        <div
          className="flex justify-around items-end my-[3vh] mx-auto py-0 px-[10%] max-w-[450px]"
        >
          <div className="flex justify-center">
            <div
              className="flex flex-col items-center"
            >
              <audio
                  className="absolute -top-[9999px]"
                  src={question.audioClip} 
                  preload="auto"
                  ref={audioElRef}
                  onEnded={() => setAudioCompleted(true)}
              />
              <div
                className="iconButtonContainer p-4 !w-[78px] !h-[78px]"
                onClick={(e) => handlePlay()}
              >
                <PlayButtonSvg className="h-[50px] w-[50px]" />
              </div>
              <div
                className="text-sm mt-2 text-center text-[#3a3a3a] font-bold"
              >
                {text}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  export default AudioClipContainer;